import ContabilitaFatturazioneStruttureDocumentiList from "./pages/ContabilitaFatturazioneStruttureDocumentiList.vue";


export default {
    ContabilitaFatturazioneStruttureDocumentiList,
};
